<template lang="pug">
  #my-friends
    WtTitle(card-title) Friends
    WtRouterLink.is-size-7.wt-entity-list-view-all(
      :to="this.$route.name === 'MyDashboard' ? 'Friends' : 'ProfileFriends'"
      :params="{ username: username }"
    ) View All

    .my-friends-gallery
      .columns.is-multiline.is-mobile
        template(v-for="friend in data.slice(0, 18)")
          .column.is-narrow.has-username-tooltip
            WtRouterLink(
              to="ProfilePage"
              :params="{ username: friend.username }"
            )
              EntityAvatar(:image="friend.avatar" size-class="is-48x48")
              .username-tooltip @{{ friend.username }}

</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

export default {
  name: "MyDashboardMyFriends",

  components: {
    EntityAvatar,
    WtButton,
    WtTitle,
    WtRouterLink
  },

  props: {
    data: {
      type: Array,
      required: true
    },
    username: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="sass" scoped>
#my-friends
  position: relative
  .wt-entity-list-view-all
    position: absolute
    top: 0
    right: 0
  .username-tooltip
    display: none
    position: absolute
  .has-username-tooltip
    position: relative
    font-size: $size-normal
    &:hover
      .username-tooltip
        display: block
</style>
